export const API_EXTERNAL_ENDPOINT = 'outings/user'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/outings/list'
